import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import {
  Breakpoint,
  FireflyMobilePopoverComponent,
  FireflyModalService,
  ModalRef
} from '@capital-access/firefly/components';
import { TARGETING_COMMON_KEY } from '../../constants';

@Component({
  selector: 'ca-best-fund',
  templateUrl: './best-fund-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BestFundIconComponent {
  @Input() rootCssClass = '';

  localizationKey: string = TARGETING_COMMON_KEY;
  private modal: ModalRef<unknown> | null = null;

  constructor(protected modalService: FireflyModalService) {}

  openMobilePopover({ title, text }: { title: string; text: string }) {
    if (this.modal || window.innerWidth > Breakpoint.Sm) return;

    this.modal = this.modalService.open({
      context: { content: text },
      component: FireflyMobilePopoverComponent,
      title: title,
      mobile: true
    });

    this.modal.result.finally(() => {
      this.modal = null;
    });
  }
}
